import { render, staticRenderFns } from "./CardStatus.vue?vue&type=template&id=a6ba3f36&"
import script from "./CardStatus.vue?vue&type=script&lang=js&"
export * from "./CardStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports